import React from 'react';
import { Route, IndexRedirect } from 'react-router';
import { Error404, Error500 } from 'barnyard/pages';
import Root from './root';
import { APP_URL } from './constants';

import signup from './signup';
import merchants from './merchants';

const routes = (
  <Route
    path={`/${APP_URL}`}
    component={Root}
    onTransitionError={Error500}
  >
    <IndexRedirect to={signup.NAME} />
    {signup.routes()}
    {merchants.routes()}
    <Route path="500" component={Error500} />
    <Route path="*" component={Error404} />
  </Route>
);

export default routes;
